import { useEffect, useRef, useState } from "react";

const Logo = ({ height = 48, testId = "ibmct-logo" }) => {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    // If the video is already buffered enough (cached), reveal immediately.
    if (v.readyState >= 2) setReady(true);
    v.play().catch(() => {});
  }, []);

  const badgeSize = height + 16;
  const mediaStyle = {
    height,
    width: "auto",
    transform: "scale(1.02)",
    transformOrigin: "center",
    filter: "brightness(1.18) contrast(1.14) saturate(1.16)",
  };

  return (
    <span
      data-testid={`${testId}-badge`}
      className="relative inline-flex items-center justify-center shrink-0 rounded-full overflow-hidden"
      style={{
        width: badgeSize,
        height: badgeSize,
        background:
          "radial-gradient(circle at 50% 45%, #241A12 0%, #1A130B 78%, #0F0A05 100%)",
        boxShadow:
          "0 0 0 1.5px #C98A2E, 0 0 0 3px rgba(23,18,13,0.85), 0 0 14px -2px rgba(201, 138, 46, 0.55), inset 0 0 12px rgba(201, 138, 46, 0.18)",
      }}
    >
      {/* Static fallback shown instantly while the MP4 buffers — prevents flicker */}
      <img
        src="/assets/logo_poster.png"
        alt=""
        aria-hidden="true"
        data-testid={`${testId}-fallback`}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 block pointer-events-none"
        style={mediaStyle}
      />
      <video
        ref={ref}
        data-testid={testId}
        src="/assets/logo.mp4"
        poster="/assets/logo_poster.png"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        aria-label="IBMCT emblem — animated logo"
        onLoadedData={() => setReady(true)}
        onCanPlay={() => setReady(true)}
        onPlaying={() => setReady(true)}
        className="relative block"
        style={{ ...mediaStyle, opacity: ready ? 1 : 0, transition: "opacity 450ms ease" }}
      />
    </span>
  );
};

export default Logo;
